.cl{flex-shrink:0;}